import { template as template_a87efb24f1dc42648ad3d847c2c375de } from "@ember/template-compiler";
import { modifier } from 'ember-modifier';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import Component from '@glimmer/component';
import LinkButton from 'ember-simplepractice/components/spds/action/button/link';
import Message from 'ember-simplepractice/components/spds/feedback/alert-banner/message';
import styles from './transfer-setup-banner.module.scss';
import t from 'ember-intl/helpers/t';
const BANNER_TITLE_ID = 'billing-transfer-banner-title';
export default class SiteBillingTransferSetupBanner extends Component {
    @service
    billingTransfer;
    hideDecorativeIcon = modifier((element)=>{
        element.querySelector('.spds-feedback-alert-banner-icon')?.setAttribute('aria-hidden', 'true');
    });
    openSetupTask = task({
        drop: true
    }, async ()=>{
        this.billingTransfer.track('Client Billing Transfer Complete Setup Clicked', {
            object: 'Client Billing Transfer Complete Setup',
            action: 'Clicked',
            'nav_location': 'client portal billing'
        });
        this.billingTransfer.openModal();
    });
    static{
        template_a87efb24f1dc42648ad3d847c2c375de(`
    {{#if this.billingTransfer.showBanner}}
      <div
        class={{styles.component}}
        role="status"
        aria-labelledby={{BANNER_TITLE_ID}}
        data-test-billing-transfer-banner
        {{this.hideDecorativeIcon}}
      >
        <Message @type="info" @includeIcon={{true}} @classNames="icon-inline">
          <:body>
            <h4 id={{BANNER_TITLE_ID}} class="spds-feedback-alert-banner-header banner-title">
              {{t "billing.transferSetup.banner.title" brandName=this.billingTransfer.brandName}}
            </h4>
            <LinkButton
              @text={{t "billing.transferSetup.banner.completeSetup"}}
              class="cta-link"
              data-test-billing-transfer-banner-cta
              {{on "click" this.openSetupTask.perform}}
            />
          </:body>
        </Message>
      </div>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
